// polyfills for ie11
import 'core-js/features/dom-collections/for-each';
import 'core-js/features/array/fill';

import React from "react";
import ReactDOM from "react-dom";
import Form from './components/Form';
import './calendar';
import '../assets/scss/style.scss';
import { normalizeDate } from "./date";

const lists = document.querySelectorAll('.pt-react-teaserlist');
lists.forEach(list => {
	if ('true' === list.getAttribute('data-mounted')) {
		return;
	}

	// eslint-disable-next-line prefer-const
	let items = window[ list.getAttribute('data-list-item-var-name') ].slice();
	const language = list.getAttribute('data-lang');
	const itemType = list.getAttribute('data-item-type');
	const hasPastItems = list.getAttribute('data-has-past-items') ?
		list.getAttribute('data-has-past-items') === 'true' : true;
	const itemDisplayOrder = list.getAttribute('data-item-display-order') || 'desc';
	const hasImages = list.getAttribute('data-has-images') === 'true';
	const hasMonthSelection = list.getAttribute('data-has-month-selection') === 'true';
	const hasTopicSelection = list.getAttribute('data-has-topic-selection') === 'true';

	// pre-filter items by type
	if (itemType) {
		items = items.filter(item => item.type === itemType);
	}

	// ensure all entries have their dates set to the correct format for the target language
	items.forEach((item, index, array) => array[ index ] = normalizeDate(item, language));

	ReactDOM.render(
		<Form
			items={ items }
			itemDisplayOrder={ itemDisplayOrder }
			language={ language }
			hasImages={ hasImages }
			hasMonthSelection={ hasMonthSelection }
			hasTopicSelection={ hasTopicSelection }
			hasPastItems={ hasPastItems }
		/>,
		list,
		() => {
			list.setAttribute('data-mounted', 'true');
		}
	);
});
